import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE || "/api";

function getAuthHeaders() {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

// Products
export async function fetchProducts() {
  const res = await axios.get(`${API_BASE}/products`);
  return res.data;
}

// Cart
export async function fetchCart(userId = 1) {
  const res = await axios.get(`${API_BASE}/carts/${userId}`, {
    headers: getAuthHeaders(),
  });
  return res.data;
}

export async function addToCart({ cartId, productId, quantity = 1 }) {
  const res = await axios.post(
    `${API_BASE}/cart-items`,
    { cartId, productId, quantity },
    { headers: getAuthHeaders() }
  );
  return res.data;
}

export async function updateCartItem(cartItemId, quantity) {
  const res = await axios.patch(
    `${API_BASE}/cart-items/${cartItemId}`,
    { quantity },
    { headers: getAuthHeaders() }
  );
  return res.data;
}

export async function removeCartItem(cartItemId) {
  await axios.delete(`${API_BASE}/cart-items/${cartItemId}`, {
    headers: getAuthHeaders(),
  });
  return { success: true };
}

// Checkout
export async function checkout(cartId, { taxRate = 0.15, shippingFee = 99.0 } = {}) {
  const res = await axios.post(
    `${API_BASE}/checkout`,
    { cartId, taxRate, shippingFee },
    { headers: getAuthHeaders() }
  );
  return res.data;
}